import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import styles from "./phoneNumber.module.scss";
import React from "react";
import { useTranslation } from "react-i18next";

interface IRemoveDialogProps {
  open: boolean;
  onClose: () => void;
  onRemove: () => void;
}

export const RemovePhoneNumberDialog: React.FC<IRemoveDialogProps> = (
  props
) => {
  const { t } = useTranslation();
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogContent>
        <DialogTitle>{t("Delete phone number")}</DialogTitle>
        <DialogContentText color="primary">
          {t("Are you sure you want to delete the phone number?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary" variant="text">
          {t("Cancel")}
        </Button>
        <Button
          variant="contained"
          className={styles.removeButton}
          onClick={props.onRemove}
        >
          {t("Remove")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
